module.exports = __webpack_public_path__ + "img/IMG_5391 2.8b310a89.webp";